// import React, { useState, useEffect } from 'react';
// import Header from '../components/Header';
// import Loading from '../components/Loader';
// import ErrorPage from './ErrorPage';
// import HtmlGameLaunchWindow from '../components/HtmlGameLaunchWindow';
// import queryString from 'query-string';

// const HtmlLaunch = (props) => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [iframeContent, setIframeContent] = useState('');
//   const [status, setStatus] = useState(true);
//   const launchData = queryString.parse(window.location.search);
//   const launchObj = JSON.parse(launchData.params);
//   useEffect(() => {
//     const fetchGameData = async () => {
//       if (!launchObj?.url) {
//         setError("Invalid launch data.");
//         return;
//       }
//       setStatus(false);
//       try {
//         const apiUrl = launchObj?.url.plex_service_endpoint;
//         if (!apiUrl) {
//           setError("Missing API endpoint.");
//           return;
//         }

//         // Create a copy and remove the unwanted property
//         const launchPayload = { ...launchObj.url };
//         delete launchPayload.plex_service_endpoint;

//         setLoading(true);
//         const response = await fetch(apiUrl, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(launchPayload),
//         });
//         if (!response.ok) throw new Error('Failed to fetch game data');
//         const data = await response.text(); // Assuming API returns HTML
//         const resObj = JSON.parse(data);
//         setIframeContent(resObj.data.game_url);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchGameData();
//   }, [status]);

//   if (loading) {
//     return (
//       <div>
//         <Header title="Game Launch" />
//         <Loading />
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorPage errorMessage={error} />;
//   }

//   return (
//     <div>
//       <HtmlGameLaunchWindow url={iframeContent} />
//     </div>
//   );
// };

// export default HtmlLaunch;


import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Loading from '../components/Loader';
import ErrorPage from './ErrorPage';
import HtmlGameLaunchWindow from '../components/HtmlGameLaunchWindow';
import queryString from 'query-string';

const HtmlLaunch = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [iframeContent, setIframeContent] = useState('');
  const [status, setStatus] = useState(true);
  const launchData = queryString.parse(window.location.search);
  // Extract `url` param and decode + parse it
  let launchObj = {};
  try {
    launchObj.url = JSON.parse(decodeURIComponent(launchData.url));
  } catch (err) {
    launchObj.url = null;
  }

  useEffect(() => {
    const fetchGameData = async () => {
      if (!launchObj?.url) {
        setError("Invalid launch data.");
        return;
      }

      setStatus(false);
      try {
        const apiUrl = launchObj?.url.plex_service_endpoint;
        if (!apiUrl) {
          setError("Missing API endpoint.");
          return;
        }

        // Clone payload and remove internal-only fields
        const launchPayload = { ...launchObj.url };
        delete launchPayload.plex_service_endpoint;

        setLoading(true);
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(launchPayload),
        });

        if (!response.ok) throw new Error('Failed to fetch game data');

        const data = await response.text(); // assuming API returns HTML stringified
        const resObj = JSON.parse(data);
        setIframeContent(resObj.data.game_url);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGameData();
  }, [status]);

  if (loading) {
    return (
      <div>
        <Header title="Game Launch" />
        <Loading />
      </div>
    );
  }

  if (error) {
    return <ErrorPage errorMessage={error} />;
  }

  return (
    <div>
      <HtmlGameLaunchWindow url={iframeContent} />
    </div>
  );
};

export default HtmlLaunch;
